import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  CheckCircleIcon,
  CancelIcon,
  WatchLaterIcon,
} from 'imports/IconsImports';

import {
  LinearProgress,
} from 'material-ui';

import {SignButtonComponent} from 'imports/ComponentsImports';

 const styles = {
   signatureBar: {
     backgroundColor:'#FFFFFF',

     marginLeft:'-22px',
     marginRight:'-22px',
     display:'flex',
     paddingTop:'5px',
     paddingBottom:'5px',
     boxShadow: '0px 0px 5px 1px #DDDDDD'
   },
   signatures: {
     width:'75%',
     display:'flex',
     flexDirection:'row',
     alignItems:'center',
     justifyContent: 'space-around'
   },
   person: {
     color:'#212f55',
     textAlign:'center',
     fontFamily: 'Lato',
     textTransform:'uppercase',
     fontSize:'10px'
   },
   title: {
     width:'25%'
   },
   text: {
     marginLeft:'20px',
     color:'#212f55',
     fontFamily: 'Lato',
     textTransform:'uppercase',
     fontSize:'14px'
   },
   signed: {
     color: '#388E3C',
     fontSize: '10px'
   },
   nosigned: {
     color: '#BF360C',
     fontSize: '10px'
   },
   waiting: {
     color: '#212f55',
     fontSize: '10px'
   }
 }

class Signature extends Component {
  constructor(props){
    super(props);
    this.state = {
      who_sign: [],
      signatures: [],
      loading: true,
      error: false,
      open: false,
      decision: "waiting",
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    };
  }

  componentDidMount(){
    this.getSignatures();
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  handleNoSign = () => {
    this.setState({open: false, decision: 'nosigned'});
    this.signProject('nosigned');
  };

  handleSign = () => {
    this.setState({open: false, decision: 'signed'});
    this.signProject('signed');
  };

  getSignatures = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.signatures(this.props.project.id))
      .then((response) => {
        this.setState({
          signatures: response.data.signatures,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
          loading: false,
        })
      });
  }

  signProject = (decision) => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    var sign = {'user_id': this.state.user.id, 'decision': decision}
    connection.post(routes.signProject(this.props.project.id), sign)
      .then((response) => {
        this.setState({
          open: false
        });
      })
      .catch((error) => {
        this.setState({
          open: false
        })
      });
  }

  getPosition = (signature) => {
    if(signature.user_position === 'Gerente de área' && signature.user_area_id === 2)
      return 'Gerente de finanzas';
    if(signature.user_position === 'Gerente de área' && signature.user_area_id === 7)
      return 'Control de gestión'
    return signature.user_position
  }

  getIcon = (signature) => {
    var position = this.getPosition(signature);
    var decision = signature.decision
    console.log('decision: ' + decision + ' position: ' + position);
    if(decision === "signed" || this.state.decision === "signed"){
      return(<div key={signature.user_id} style={styles.person}><CheckCircleIcon style={styles.signed}/><br />{position}</div>);
    }else if (decision === "nosigned" || this.state.decision === "nosigned") {
      return(<div key={signature.user_id} style={styles.person}><CancelIcon style={styles.nosigned}/><br />{position}</div>);
    }else if ((decision === "next" || this.state.decision === "next") && this.state.user.id === signature.user_id){
      return(<div key={signature.user_id} style={styles.person}>
        <SignButtonComponent token={this.state.token} project={this.props.project} user={this.state.user}/>
        <br />{position}</div>)
    }
    else{
      return(<div key={signature.user_id} style={styles.person}><WatchLaterIcon style={styles.waiting}/><br />{position}</div>);
    }
  }

  render() {
    console.log(this.state.signatures);
    return (
      <div style={styles.signatureBar}>
        <div style={styles.title}>
          <p style={styles.text}>Proyecto en proceso de firma</p>
        </div>
        <div style={styles.signatures}>
          {(()=>{
            if(this.state.loading){
               return(<div style={{width:'80%'}}><LinearProgress color='#9e9e9e'  mode="indeterminate" /></div>)
            }
            if(this.state.error){
              return(<div>Hubo un error al cagar las firmas.</div>)
            }
          })()}
          {this.state.signatures.map((signature) =>{
            return(this.getIcon(signature))
          })}
        </div>
      </div>
    );
  }
}

export default withCookies(Signature);



// WEBPACK FOOTER //
// ./src/components/files/Signature.js